export enum ForumType {
  General = 'GENERAL',
  Supplier = 'SUPPLIER',
}
